export default "__VITE_PUBLIC_ASSET__0cd8455b__"